import styled from 'styled-components';
import { css, breakpoints } from 'src/styles/theme';
import { FeatureDemandBannerStyled } from '../FeatureDemandBannerStyled';
import { rem } from 'polished';

export const FeatureDemandBannerAC = styled(FeatureDemandBannerStyled)`
    
`;
